module.exports = __webpack_public_path__ + "static/img/NG.9b228d02.svg";